import Button from "./Button";
import "./FullScreenImage.css";
import { ReactComponent as Dismiss } from "./static/icons/Dismiss-small.svg";

function FullScreenImage({ children, onClose }) {
  return (
    <div className="Modal-overlayFS" onClick={onClose}>
      <div className="ModalFS" onClick={(e) => e.stopPropagation()}>
        <div className="closeButtonRow">
          <Button
            id="modal-dismissFS"
            variant="icon"
            onClick={onClose}
            icon={<Dismiss />}
          ></Button>
        </div>
        {children}
      </div>
    </div>
  );
}

export default FullScreenImage;
